import React from 'react'
import { Button } from 'primereact/button'
import { Checkbox } from 'primereact/checkbox'
import { EcommerceResponse, IEcommerceQuestionSchema } from './types'
import useSurveyLocale from '../../modules/locale/useSurveyLocale'
import style from './style.module.scss'
import useTimeline from '../../modules/timeline/useTimeline'

interface IClosedShelfViewProps {
  schema: IEcommerceQuestionSchema
  response: EcommerceResponse
  store?: string
  onAction: () => void
  onUpdateResponse: (response: EcommerceResponse) => void
}
const ClosedShelfView = ({ schema, response, onAction, onUpdateResponse, store }: IClosedShelfViewProps) => {
  const { t } = useSurveyLocale()
  const timeline = useTimeline()
  const naAnswer = schema.answers.find(answer => answer.na)
  const naResponse = response.answers.find(answer => answer.id == naAnswer?.id)
  const naChecked = naResponse?.v > 0

  const onNaSelect = () => {
    timeline.log({
      type: 'na_select',
      ref: naAnswer.id
    })

    if (schema.store === 'amazonw') {
      response.answers = naChecked ? [] : [{ v: 1, id: naAnswer.id }]
    } else {
      const answers =
        naResponse.v > 0
          ? response.answers.map(answer => {
              if (answer.id === naAnswer.id && answer.v > 0) {
                answer.v = 0
              }
              return answer
            })
          : response.answers.map(answer => {
              answer.v = answer.id === naAnswer.id ? 1 : 0
              return answer
            })
      response.answers = answers
    }
    onUpdateResponse(response)
  }

  return (
    <fieldset className={`${style.closedShelfView}`} data-testid="SW-SH" aria-labelledby="sh-label">
      <span>{t<(store: string) => string>('questions', 'ec', 'amazon', 'backToStoreNote')(store || '')}</span>
      <div className={style.buttons} data-testid="SW-SFT-Buttons">
        <Button
          data-testid="SW-SH-ButtonStart"
          label={t('questions', 'ec', 'amazon', 'open').toString()}
          className={style.button}
          onClick={onAction}
          disabled={naChecked}
        />
      </div>
      {naAnswer && (
        <label className={style.naAnswerRow}>
          <Checkbox
            value={naAnswer?.id}
            data-testid="SW-RB-Answer-Checkbox"
            onChange={onNaSelect}
            checked={naChecked}
          />
          <div className={style.naAnswerText}>{naAnswer.text}</div>
        </label>
      )}
    </fieldset>
  )
}

export default ClosedShelfView
